/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_SearchInputs */

const id_staff_resellers_search = /** @type {(inputs: Staff_Resellers_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari perusahaan atau kontak`)
};

const en_staff_resellers_search = /** @type {(inputs: Staff_Resellers_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search company or contact`)
};

/**
* | output |
* | --- |
* | "Search company or contact" |
*
* @param {Staff_Resellers_SearchInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_search = /** @type {((inputs?: Staff_Resellers_SearchInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_SearchInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_search(inputs)
	return id_staff_resellers_search(inputs)
});